<template>
    <div class="o-inc-dec" v-click-outside="hide">
        <input readonly
            class="form-control has-icon has-icon-person readonly-normal curs-point"
            placeholder="Passengers"
            type="number"
            :value="total > 0 ? total : ''"
            @click="toggle()" />

        <div
            class="o-inc-dec__drop is-rounded"
            :class="{ active: active }">
            <number-input required
                title="Adults"
                subtitle="14+ years old"
                name="pax_adl"
                :max="20"
                :min="0"
                v-model="value.adl"
            ></number-input>

            <number-input
                title="Children"
                subtitle="6-13 years old"
                name="pax_chd"
                :max="20"
                :min="0"
                v-model="value.chd"
            ></number-input>

            <number-input
                title="Infants"
                subtitle="0-5 years old"
                name="pax_inf"
                :max="20"
                :min="0"
                v-model="value.inf"
            ></number-input>

            <div class="d-flex justify-content-end">
                <button type="button" class="btn btn-sm btn-secondary" @click="hide">OK</button>
            </div>
        </div>
    </div>
</template>

<script>
import NumberInput from './NumberInput.vue'
import ClickOutside from 'vue-click-outside'

export default {
    components: {
        NumberInput
    },
    props: {
        value: {
            type: Object,
            default: {
                adl: 0,
                chd: 0,
                inf: 0,
            }
        }
    },
    directives: {
        ClickOutside
    },
    data() {
        return {
            active: false,
            count: {
                adl: 0,
                chd: 0,
                inf: 0,
            }
        }
    },
    computed: {
        total() {
            return Object.values(this.value).reduce((value, total) => value + total)
        }
    },
    watch: {
        count: {
            handler() {
                this.$emit('input', this.count)
            },
            deep: true
        }
    },
    methods: {
        toggle() {
            this.active = !this.active
        },
        hide() {
            this.active = false
        }
    }
}
</script>